module.exports = __webpack_public_path__ + "img/logo.8b3477d6.jpg";